var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#C6F7B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 26L23.1067 23.1067M24.6667 19.3333C24.6667 22.2789 22.2789 24.6667 19.3333 24.6667C16.3878 24.6667 14 22.2789 14 19.3333C14 16.3878 16.3878 14 19.3333 14C22.2789 14 24.6667 16.3878 24.6667 19.3333Z",
    stroke: "#4FBF26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.8daaa8535dfe190d16d39b6762a50f10.svg";
export { ForwardRef as ReactComponent };